import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PythonModuleService } from '../../services/python-module.service';
import { takeUntil, Subject } from 'rxjs';

@Component({
  selector: 'app-get-url',
  templateUrl: './get-url.component.html',
  styleUrls: ['./get-url.component.scss']
})
export class GetURLComponent implements OnInit, OnDestroy {
route: ActivatedRoute;
fileName: string | null = null;
downloadURL: string | null = null;
downloadType: string | null = null;
private destroy$ = new Subject<void>();

constructor(
  private readonly pythonModuleService: PythonModuleService,
  route: ActivatedRoute
) {
  this.route = route;
}

downloadZipFile() {
  this.pythonModuleService.downloadZipFile(this.route.snapshot.paramMap.get('engagementId'), this.route.snapshot.paramMap.get('moduleId'), this.route.snapshot.paramMap.get('runId')).pipe(takeUntil(this.destroy$)).subscribe({
    next: (response: any) => {
      let filename = 'output-files.zip';
      const blob = response.body;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      this.downloadURL = 'success';
      setTimeout(() => window.close(), 1000);
    },
    error: (error: any) => {
      console.log(error);
      this.downloadURL = 'error';
    }
  });
}

downloadSupportFile() {
  const engagementId = this.route.snapshot.paramMap.get('engagementId');
  const moduleId = this.route.snapshot.paramMap.get('moduleId');
  const fileName = this.route.snapshot.queryParamMap.get('fileName');
    
  this.pythonModuleService.downloadSupplementalFile(engagementId, moduleId, fileName).pipe(takeUntil(this.destroy$)).subscribe({
    next: (response: any) => {
      const filename = fileName || 'support-file';
      const blob = response.body;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      this.downloadURL = 'success';
      setTimeout(() => window.close(), 1000);
    },
    error: (error: any) => {
      console.log(error);
      this.downloadURL = 'error';
    }
  });
}

ngOnInit(): void {
  this.downloadType = this.route.snapshot.queryParamMap.get('type');
    
  if (this.downloadType === 'support') {
    this.downloadSupportFile();
  } else {
    this.downloadZipFile();
  }
}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
